export const dapCommonLang: object = Object.freeze({
  serviceName: {
    ja: 'サービス名',
    en: 'Service Name',
  },
  mDefaultPlaceholder: {
    ja: '検索キーワードを入力',
    en: 'Input search keywords',
  },
  zeroHit: {
    ja: '検索条件に適合するデータがありませんでした。',
    en: 'No result on this search condition.',
  },
  externalSite: {
    ja: '外部サイト',
    en: 'External Site',
  },
  news: { ja: 'お知らせ', en: 'News' },
  numFound: { ja: '{}件見つかりました', en: '{} records found' },
  buttonReset: { ja: 'リセット', en: 'Reset' },
  gallery: { ja: 'ギャラリー', en: 'Gallery' },
  organization: { ja: '連携機関', en: 'Organization' },
  add: { ja: '追加', en: 'Add' },
  addOf: { ja: '{}の追加', en: 'Add {}' },
  addSuccess: { ja: '{}を追加しました', en: '{} added' },
  cancel: { ja: 'キャンセル', en: 'Cancel' },
  close: { ja: '閉じる', en: 'Close' },
  copy: { ja: 'コピー', en: 'Copy' },
  copySuccess: { ja: 'コピーしました。', en: 'Copied' },
  create: { ja: '作成', en: 'Create' },
  created: { ja: '作成日', en: 'Created date' },
  csearch: { ja: 'テーマ別検索', en: 'Designed Search' },
  database: { ja: 'データベース', en: 'Database' },
  project: { ja: 'プロジェクト', en: 'Project' },
  ok: { ja: '決定', en: 'OK' },
  delete: { ja: '削除', en: 'Delete' },
  desc: { ja: '説明', en: 'Description' },
  facetMenu: { ja: '検索結果の絞り込みメニュー', en: 'Facet Menu' },
  finished: { ja: '完了', en: 'Finished' },
  id: { ja: 'ID', en: 'ID' },
  keyword: { ja: 'キーワード', en: 'Keyword' },
  keywordOr: { ja: 'どれか含む', en: 'Or' },
  lastUpdated: { ja: '最終更新日', en: 'Last updated' },
  logout: { ja: 'ログアウト', en: 'Sign Out' },
  map: { ja: '地図', en: 'Map' },
  metadataCount: { ja: 'メタデータ件数', en: 'Number of metadata' },
  more: { ja: 'もっと見る', en: 'Show more' },
  hide: { ja: '隠す', en: 'Hide' },
  show: { ja: '表示', en: 'Show' },
  name: { ja: '名前', en: 'Name' },
  next: { ja: '次へ', en: 'Next' },
  no: { ja: 'いいえ', en: 'No' },
  note: { ja: 'ノート', en: 'Note' },
  noTitle: { ja: '（タイトル無し）', en: '(No Title)' },
  pagination: { ja: 'ページネーション', en: 'Pagination' },
  permission: { ja: '権限', en: 'Permission' },
  prev: { ja: '前へ', en: 'Previous' },
  save: { ja: '保存', en: 'Save' },
  searchHistory: { ja: '検索履歴', en: 'Search History' },
  searchPref: { ja: '検索設定', en: 'Search Preference' },
  searchResults: { ja: '検索結果', en: 'Search Results' },
  public: { ja: '公開', en: 'Publication' },
  sort: { ja: '並び替え', en: 'Sort' },
  targetDb: { ja: '対象データベース', en: 'Target databases' },
  title: { ja: 'タイトル', en: 'Title' },
  select: { ja: '選択', en: 'Select' },
  unselect: { ja: '未選択にする', en: 'Unselect' },
  unselected: { ja: '未選択に戻す', en: 'Clear selection' },
  upload: { ja: 'アップロード', en: 'Upload' },
  updated: { ja: '更新', en: 'Updated' },
  yes: { ja: 'はい', en: 'Yes' },
  partner: {
    ja: '連携機関',
    en: 'Partners', //"Provider"
  },
  provider: {
    ja: '所蔵・所在',
    en: 'Contents holder/Provider', //"Provider"
  },
  agregator: {
    ja: 'つなぎ役',
    en: 'Aggregator', //"Aggregator"
  },
  createSuccess: { ja: '{}を作成しました', en: '{} is created' },
  deleteConfirm: {
    ja: '{}を削除してよろしいですか？',
    en: 'Will you delete {}?',
  },
  deleteFail: {
    ja: '{}を削除できませんでした',
    en: '{} can not be deleted',
  },
  deleted: { ja: '削除しました', en: 'Deleted' },
  deleteSuccess: { ja: '{}を削除しました', en: '{} is deleted' },
  undo: { ja: '元に戻す', en: 'Undo' },
  redo: { ja: 'やり直す', en: 'Redo' },
  updateSuccess: {
    ja: '{}を更新しました',
    en: '{} has been updated',
  },
  uploadFail: {
    ja: '{}のアップロードに失敗しました',
    en: '{} can not be uploaded',
  },
  uploadSuccess: {
    ja: '{}をアップロードしました',
    en: '{} has been uploaded',
  },
  buttonClosure: {
    ja: '開閉ボタン',
    en: 'closure button',
  },
  contact: {
    name: {
      ja: '事務局',
      en: 'Office',
    },
    mail: {
      ja: 'ml-renkei@ndl.go.jp',
      en: 'ml-renkei@ndl.go.jp',
    },
  },
  quickSearchLink: {
    ja: 'サイト内を検索',
    en: 'Search',
  },
  metadata: {
    common: {
      label: {
        ja: '共通メタデータ',
        en: 'Common Meta data'
      },
    },
  },
  datasource: {
    ja: 'データベース',
    en: 'Data source'
  },
  db: {
    recordCount: {
      ja: 'レコード数',
      en: 'Record'
    },
  },
  slideShow: {
    next: {
      ja: '次のスライド',
      en: 'Next',
    },
    previous: {
      ja: '前のスライド',
      en: 'Previous',
    },
    pause: {
      ja: 'スライドショーの自動再生を停止',
      en: 'Pause slide show',
    },
    resume: {
      ja: 'スライドショーの自動再生',
      en: 'resume slide show',
    },
  },

  search: {
    ja: '検索',
    en: 'Search',
  },
  imageSearch: {
    ja: '画像AI検索',
    en: 'Image AI Search',
  },
  imageOnly: {
    ja: 'コンテンツをオンラインで閲覧できるものに絞る',
    en: 'Items with available on the web',
  },
  imageOnlyDescription: {
    ja: 'デジタル画像など、オンラインで内容を直接見られる資料だけを表示します。',
    en: 'The search results show only items you can view online.',
  },
  // 類似画像検索
  searchImage: {
    ja: '画像を使って探す',
    en: 'Search by Image',
  },
  searchImageWithImage: {
    ja: '{}に登録されている画像で検索',
    en: 'Search with images in {}',
  },

  viewOnSite: {
    ja: 'サイトで表示',
    en: 'View on the site',
  },

  // キュレーションエクスポートモーダル
  curationModal: {
    table: {
      title: {
        ja: 'タイトル',
        en: 'Title',
      },
      description: {
        ja: '注釈',
        en: 'Description',
      },
      url: {
        ja: '{}上のURL',
        en: 'URL on {}',
      },
      originalUrl: {
        ja: 'オリジナルURL',
        en: 'Original URL',
      },
    }
  },

  // クッキー許諾モーダル
  gdprModal: {
    title: {
      ja: '{}でのクッキーの使用',
      en: 'Our use of Cookies on {}',
    },
    details: {
      ja: `当ウェブサイト（{}/）は、公共サービスとしてウェブサイトを機能させるために必要なクッキー（Cookie）を使用しています。また、当ウェブサイトの利用状況を計測し、改善に役立てるためのアクセス解析クッキーを設定することもありますが、このクッキーは、利用者が同意した場合にのみ設定されます。同意はいつでも取り消すことができます。`,
      en: `We used necessary cookies to make our website ({}/) work as public services. We would also like to set analytics cookies that help us make improvements by measuring how you use our website. These cookies will be set only if you accept. You can revoke your consent with effect for the future at any time via the cookie settings.`,
    },
    strictlyNecessary: {
      ja: 'ウェブサイトの正常な動作に「必要最小限」のクッキー（常に有効）',
      en: 'Strictly Necessary Cookies : Always Enabled',
    },
    strictlyNecessary1: {
      ja: '当ウェブサイトは、セキュリティ、ネットワーク管理、アクセシビリティなどの基本的な機能を正常に機能させるために必須なクッキーをあらかじめ設定しています',
      en: 'Necessary cookies enable core functionality such as security, network management and accessibility.',
    },
    strictlyNecessary2: {
      ja: 'ブラウザのクッキー設定を変更することで、必要最小限のクッキーを無効にできますが、ウェブサイトの機能に影響を与える場合があります。',
      en: 'You may disable these by changing your browser settings, but this may affect how the website functions.',
    },
    acceptAnalyticsCookies: {
      ja: '「全て同意」を選択した場合に設定されるクッキー（アクセス解析）',
      en: 'Accept all Cookies : Analytics Cookies',
    },
    acceptAllCookiesDescription: {
      ja: '当ウェブサイトのアクセス統計機能又はGoogle Analyticsを使用して、アクセスログの収集・解析によりウェブサイト利用者の利用パターンを計測し、サービスの評価・改善に役立てます。',
      en: "By using our website's statistical function or Google Analytics, we collect website analytics information about usage patterns of website to evaluate and improve our services.",
    },
    acceptAllCookiesDescription1: {
      ja: 'クッキーとは、利用者がウェブサイトにアクセスしたときに、ご利用の端末（スマートフォンやタブレット、PC等）に保存される小さなテキストファイルです。',
      en: 'Cookies are small text files that are stored on your device (smartphone, tablet, laptop, etc.) when you visit our websites. ',
    },
    acceptAllCookiesDescription2: {
      prefix: {
        ja: 'より詳しく知りたい方は、',
        en: 'For any question in relation to our policy on cookies, please see ',
      },
      base: {
        ja: 'プライバシーポリシー',
        en: 'privacy policy',
      },
      suffix: {
        ja: 'をご確認ください。',
        en: '.',
      },
    },
    strictlyNecessaryCookies: {
      ja: '必要最低限',
      en: 'Strictly Necessary Cookies',
    },
    forMoreInformation: {
      ja: '詳細を見る',
      en: 'For more information',
    },
    hideInformation: {
      ja: '詳細を隠す',
      en: 'Hide information',
    },
    acceptAllCookies: {
      ja: 'すべて同意',
      en: 'Accept all Cookies',
    },
  },

  // 画像選択
  imageSelect: {
    material: {
      ja: '{}の資料から',
      en: 'From {}',
    },
    thumbnail: {
      ja: '{}に登録された資料から、サムネイル画像を指定します。',
      en: 'Select a thumbnail from {}',
    },
    upload: {
      ja: '{}に画像をアップロードします。',
      en: 'Upload image to {}',
    },
    metadata: {
      ja: '{}上の資料を選択',
      en: 'Select an item',
    },
  },

  // 公開状態の変更
  publicationChange: {
    published: {
      ja: '{}上で公開されますが、検索対象とはなりません。APIからは、特に指定すれば検索・取得が可能です。',
      en: 'Published on {} but not included in search results.',
    }
  },

  // 管理 データ公開
  managementDataPublication: {
    beforePublication: {
      ja: '本番データ登録を実行する前に、{}へご連絡をお願いします。',
      en: 'Please contact the {} before registering production data.',
    },
    notYetContacted: {
      ja: '一般公開の前に、{}へご連絡をお願いします。まだご連絡されていない場合は「キャンセル」を押してください。',
      en: 'Please contact {} before general publication. If you have not yet contacted, please click "Cancel".',
    }
  },

  // 管理 トップ
  managementTop: {
    manageImages: {
      ja: '{}に直接アップロードした画像を管理します。',
      en: 'Manage images uploaded directly to {}',
    },
  },

  // データベース紹介ページ
  databaseIntroduction: {
    ja: '{}と連携しているデータベースの一覧です。',
    en: 'Databases connected to the {}.',
  },

  // ギャラリー
  galleryIntroduction: {
    ja: '{}で検索できるコンテンツを様々な切り口で紹介します。',
    en: 'Galleries introduce contents in various angles.',
  },

  // プロジェクト
  projectIntroduction: {
    ja: '{}上で取り組まれているプロジェクトの一覧です。',
    en: 'Projects powerd by {}.',
  },

  // トップ
  top: {
    news: {
      ja: 'お知らせ',
      en: 'News',
    },
    newDatabase: {
      ja: '新規連携データベース',
      en: 'New Database',
    },
    inputSearchKeyword: {
      ja: '検索キーワードを入力',
      en: 'Input search keyword',
    },
    search: {
      ja: '検索',
      en: 'Search',
    },
    recentSearch: {
      ja: '最近の検索',
      en: 'Recent Search',
    },
    fullSearch: {
      ja: '全件検索',
      en: 'Full Search',
    },
    searchByKeyword: {
      ja: 'キーワード検索を試してみる',
      en: 'Search by keyword',
    },
  },

  // 横断検索
  crossSearch: {
    crossSearch: {
      ja: '横断検索',
      en: 'Cross Search',
    },
    thumbnailView: {
      ja: 'サムネイル形式',
      en: 'Thumbnail view',
    },
    listView: {
      ja: 'リスト形式',
      en: 'List view',
    },
    tableView: {
      ja: '表形式',
      en: 'Table view',
    }
  },

  // アイテム
  item: {
    imageSearch: {
      ja: 'この画像に似た画像を探す',
      en: 'Find Similar Images',
    }
  },

  message: {
    'e-search-limit-error': {
      ja: '検索の上限件数に達しました。',
      en: 'You have reached the maximum number of search results.',
    }
  }

})
